<template>
  <div class="Hamburger" :class="state ? 'expanded' : 'collapsed'">
    <v-btn fab class="button" text @click="changeState">
      <span class="bars"></span>
    </v-btn>
  </div>
</template>

<script lang="js">
export default {
  data: () => ({
    _state: true,
  }),
  props: {
    state: {
      default: true,
      type: Boolean
    },
  },
  watch:{
    state: {
      immediate: true,
      handler() {
        this._state = this.state;
      }
    }
  },
  methods:{
    changeState(){
      this._state = !this._state
      this.$emit("sideNavState", this._state);
    }
  }
};
</script>

<style scoped>
.button {
  width: 22px !important;
  height: 22px !important;
}
.Hamburger {
  top: 12px;
  left: 5px;
  position: fixed;
  z-index: 7;
}
.bars {
  position: relative;
  width: 15px;
  height: 1px;
  transition: all 0.6s ease-in-out;
  border-radius: 5px;
}
.bars:before,
.bars:after {
  content: "";
  display: block;
  width: 100%;
  height: 71%;
  position: absolute;
  transition: 0.5s ease-in-out;
  border-radius: 20px;
}
.Hamburger.expanded .bars,
.Hamburger.expanded .bars:before,
.Hamburger.expanded .bars:after {
  background: #005681;
}
.Hamburger.collapsed .bars,
.Hamburger.collapsed .bars:before,
.Hamburger.collapsed .bars:after {
  background: white;
}
.bars:before {
  top: -5px;
}
.bars:after {
  bottom: -5px;
}

.Hamburger.expanded .v-btn .bars {
  transform: rotate(45deg);
}
.Hamburger.expanded .v-btn .bars:before {
  transform: rotate(90deg);
  top: 0;
}
.Hamburger.expanded .v-btn .bars:after {
  transform: rotate(90deg);
  bottom: 0;
}
</style>